const { form: accountsForm } = require('./accounts-fullcont-form')

// Copias independientes: filtrar el quickform no modifica el formulario completo.
export const accountTypeOptions = accountsForm.find((field) => field.name === 'type').options
	.map((option) => ({ ...option }))

export const form   =  [
	{
		name: 'name',
		value: '',
		id: 'accounts_quickform_name',
		html: '',
		type: 'textfield',
		required: true,
	},
	{
		name: 'type',
		value: '',
		id: 'accounts_quickform_type',
		html: '',
		type: 'multiselect',
		options: accountTypeOptions,
		required: true,
	},
	{
		name: 'code',
		value: '',
		id: 'accounts_quickform_code',
		html: '',
		type: 'textfield',
		required: false,
	},
	{
		name: 'description',
		value: '',
		id: 'accounts_quickform_description',
		html: '',
		type: 'textfield',
		required: false,
	},
]

export const formCopy = JSON.parse(JSON.stringify(form))
